import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledDropdown,
  StyledButton,
  StyledUl,
  StyledLi,
  StyledLink,
  StyledSpan,
  StyledIconDrop,
  StyledError
} from './style';

import { ArrowLeft } from '../../../../assets/images/index';

class DropdownInput extends Component {
  constructor() {
    super();
    this.state = { expanded: false, label: undefined };
  }

  onChange = (option, event) => {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(option, event);
    }
    if (option.length > 1) {
      this.setState({ expanded: false, label: 'Todos' });
    } else {
      this.setState({ expanded: false, label: option.text });
    }
  };

  onClickDropdown = e => {
    const { expanded } = this.state;
    const { disabled } = this.props;
    if (!disabled) {
      if (expanded) {
        this.setState({
          expanded: false
        });
      } else {
        this.setState({
          expanded: true
        });
      }
    }
    e.preventDefault();
  };

  getLabel = () => {
    const { labelNotification } = this.props;
    const { label } = this.state;
    if (!labelNotification) {
      return !label ? this.props.label : label;
    }
    return this.props.label;
  };

  render() {
    return (
      <StyledDropdown
        className={this.props.className}
        disabled={this.props.disabled}
        aria-labelledby={this.props.ariaLabelledby}
        tabIndex={-1}
        onClick={this.onClickDropdown}
        onMouseLeave={() => this.setState({ expanded: false })}
        small={this.props.small}
        modalActive={this.props.modalActive}
      >
        <StyledButton
          expanded={this.state.expanded}
          disabled={this.props.disabled}
          error={this.props.error}
          className="drop-button"
        >
          <StyledSpan>{this.getLabel()}</StyledSpan>
          <StyledIconDrop
            svg={ArrowLeft}
            width="13px"
            height="13px"
            color="grayDark"
            expanded={this.state.expanded}
            disabled={this.props.disabled}
            hover
          />
        </StyledButton>
        <StyledUl expanded={this.state.expanded}>
          {this.props.allowUnselected && (
            <StyledLi onClick={event => this.onChange(this.props.list, event)}>
              <StyledLink value={this.props.list}>
                Todos los usuarios
              </StyledLink>
            </StyledLi>
          )}
          {this.props.list.map(item => (
            <StyledLi
              key={`${item.id || item.value}-${item.name || item.text}`}
              onClick={event => this.onChange(item, event)}
            >
              <StyledLink value={item.id || item.value}>
                {item.text || item.name}
              </StyledLink>
            </StyledLi>
          ))}
        </StyledUl>
        {this.props.error && <StyledError>{this.props.error}</StyledError>}
      </StyledDropdown>
    );
  }
}
DropdownInput.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  label: PropTypes.string,
  onSelect: PropTypes.func,
  className: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  allowUnselected: PropTypes.bool
};

export default DropdownInput;
